import React from "react";
import { Spinner } from "react-bootstrap";
import { Loader2 } from "lucide-react";
import VFontIcon from "../icons/VFontIcon";
import { createTooltip } from "../tooltips/VTooltip";

export type IVSpinnerProps = React.Attributes & {
    variant?: string;
    size?: number;
    title?: string;
};

const VSpinner = (props: IVSpinnerProps) => {
    // For very small sizes, use Bootstrap spinner
    if (props.size && props.size < 16) {
        return createTooltip(
            <Spinner
                animation="border"
                variant={props.variant || "primary"}
                role="status"
                size={"sm"}
            />,
            props.title
        );
    }

    // For large sizes, use Bootstrap spinner
    if (props.size && props.size > 24) {
        return createTooltip(
            <Spinner
                animation="border"
                variant={props.variant || "primary"}
                role="status"
            />,
            props.title
        );
    }

    // Default case: use VFontIcon with Lucide Loader2
    return (
        <VFontIcon icon={Loader2} spin size={props.size} title={props.title} />
    );
};

export default VSpinner;
